import { supplierForecastData } from 'Interfaces/FDPInterfaces/supplierForecast';
import { makeAutoObservable } from 'mobx';
import React from 'react';
import { toast } from 'react-toastify';
import { supplierForecastService } from 'services/fdp/supplierForecastService';
import { unconstrainedForecastService } from 'services/fdp/unconstrainedForecastService';
export class SupplierForecastStore {
  isSupplierForecastLoading: boolean = false;
  isSupplierForecastDownloading: boolean = false;
  isAllSupplierForecastDownloading: boolean = false;
  suplierForecastPlanDate: string = '';
  supplierForecastData: supplierForecastData = {
    PlanningPeriod: '',
    Supplier: [
      {
        SupplierName: '',
        Segments: [
          {
            Segment: '',
            BulkNDCs: [
              {
                BulkNDC11: '',
                NDC10: '',
                OnHand: 0,
                OpenPo: 0,
                Description: '',
                Lead_Time: null,
                Pan_Size: null,
                IsCoveredDrug: false,
                forecast: [
                  {
                    ForecastPeriod: '',
                    SupplierForecast: 0,
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  };
  supplierOption: {
    name: string;
  } = {
    name: '',
  };
  supplierNames: {
    name: string;
  }[] = [];
  fssforecastData: {
    BulkNDC11: string;
    NDC10: string | null;
    OnHand: number;
    OpenPo: number;
    Description: string;
    Lead_Time: number | null;
    Pan_Size: number | null;
    IsCoveredDrug: boolean;
    forecast: {
      ForecastPeriod: string;
      SupplierForecast: number;
    }[];
  }[] = [];
  nmcforecastData: {
    BulkNDC11: string;
    NDC10: string | null;
    OnHand: number;
    OpenPo: number;
    Description: string;
    Lead_Time: number | null;
    Pan_Size: number | null;
    IsCoveredDrug: boolean;
    forecast: {
      ForecastPeriod: string;
      SupplierForecast: number;
    }[];
  }[] = [];
  coveredDrugForecastData: {
    BulkNDC11: string;
    NDC10: string | null;
    OnHand: number;
    OpenPo: number;
    Description: string;
    Lead_Time: number | null;
    Pan_Size: number | null;
    IsCoveredDrug: boolean;
    forecast: {
      ForecastPeriod: string;
      SupplierForecast: number;
    }[];
  }[] = [];
  issupplierForecastGenerating: boolean = false;
  percentProgress: { percentage: number } = { percentage: 0 };
  isUnconstrainedForecastProgressLoading: boolean = false;

  // search states
  searchInput: string = '';
  allndc10SearchData: { index: number; value: string }[] = [];
  filteredndc10SearchData: { index: number; value: string }[] = [];
  allConceptSearchData: { index: number; value: string }[] = [];
  filterConceptSearchData: { index: number; value: string }[] = [];

  private debounceTimer: ReturnType<typeof setTimeout> | null = null;
  private debounce(func: (...args: any[]) => void, delay: number) {
    return (...args: any[]) => {
      if (this.debounceTimer) clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  }

  constructor() {
    makeAutoObservable(this);
  }

  handleSearchInputChange = (input: string) => {
    this.searchInput = input;
    this.handleFilterConceptSearch();
  };

  handleFilterConceptSearch = this.debounce(() => {
    if (!this.searchInput?.trim()) {
      this.filteredndc10SearchData = [];
      this.filterConceptSearchData = [];
      return;
    }

    if (this.searchInput.match(/^\d/)) {
      // user typed a NDC
      this.filteredndc10SearchData = this.allndc10SearchData.filter(ndc =>
        ndc?.value?.includes(this.searchInput)
      );
    } else {
      // user typed a concept
      const searchText = this.searchInput.toLowerCase();
      this.filterConceptSearchData = this.allConceptSearchData?.filter(supplier =>
        supplier?.value?.toLowerCase().includes(searchText)
      );
    }
  }, 300);

  handleEnterKeyDownSearchInput = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      this.handleSearch();
    }
  };

  handleSearch = () => {
    if (this.isSupplierForecastLoading || !this.searchInput) {
      return;
    }

    if (this.searchInput.match(/^\d/)) {
      const matchedNDC10 = this.allndc10SearchData.filter(ndc => ndc.value === this.searchInput);

      if (matchedNDC10.length === 0) {
        toast.error('No NDC10 found with provided value');
      } else {
        this.setSupplierOption(null, matchedNDC10[0].index);
      }
    } else {
      const matchedConcept = this.allConceptSearchData.filter(
        concept => concept.value === this.searchInput
      );

      if (matchedConcept.length === 0) {
        toast.error('No Concept found with provided name');
      } else {
        this.setSupplierOption(null, matchedConcept[0].index);
      }
    }
  };

  getSupplierNames = () => {
    return this.supplierForecastData.Supplier.map(item => ({
      name: item.SupplierName,
    }));
  };

  getSupplierForecastData = async (planning_period: string) => {
    this.searchInput = '';
    this.isSupplierForecastLoading = true;
    try {
      this.fetchForecastProgress();
      this.suplierForecastPlanDate = planning_period;
      const data = await supplierForecastService.getSupplierForecasts(planning_period);
      this.supplierForecastData = data.data;
      this.allndc10SearchData = data.ndc10_data;
      this.allConceptSearchData = data.concept_data;

      if (data.data.Supplier.length === 0) {
        // get supplier forecast for previous month
        const currDt = new Date();
        const prev_date = new Date(currDt.setMonth(currDt.getMonth() - 1))
          .toISOString()
          .split('T')[0]
          .replace(/-\d{2}$/, '-01');

        this.suplierForecastPlanDate = prev_date;
        const prev_data = await supplierForecastService.getSupplierForecasts(prev_date);
        this.supplierForecastData = prev_data.data;
        this.allndc10SearchData = prev_data.ndc10_data;
        this.allConceptSearchData = prev_data.concept_data;
      }
      this.supplierNames = this.getSupplierNames();
      this.setSupplierOption(this.supplierNames[1]);
    } catch (error) {
      console.log('getSupplierForecastData=> ', error);
    } finally {
      this.isSupplierForecastLoading = false;
    }
  };

  setIsSupplierForecastDownloading = (flag: boolean) => {
    this.isSupplierForecastDownloading = flag;
  };
  setIsAllSupplierForecastDownloading = (val: boolean) => {
    this.isAllSupplierForecastDownloading = val;
  };

  setSupplierOption = (option: { name: string } | null = null, index: number = -1) => {
    let idx: number | null = null;
    if (index === -1 && option !== null) {
      this.supplierOption = option;
      idx = this.supplierForecastData.Supplier.findIndex(
        item => item.SupplierName === option.name || null
      );
    } else {
      idx = index;
      this.supplierOption = {
        name: this.supplierForecastData.Supplier[idx].SupplierName,
      };
    }

    this.fssforecastData = [];
    this.nmcforecastData = [];
    this.coveredDrugForecastData = [];

    for (const item of this.supplierForecastData.Supplier[idx].Segments) {
      for (const ndc of item.BulkNDCs) {
        if (ndc.IsCoveredDrug) {
          this.coveredDrugForecastData.push(ndc);
        } else if (item.Segment === 'MAS') {
          this.fssforecastData.push(ndc);
        } else if (item.Segment === 'NMC') {
          this.nmcforecastData.push(ndc);
        }
      }
    }
  };

  getCurrentDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    return `${year}-${month}-01`;
  };

  fetchForecastProgress = async () => {
    this.isUnconstrainedForecastProgressLoading = true;
    try {
      const data = await unconstrainedForecastService.getDirectUnconstrainedForecastProgress();
      this.percentProgress = data;
    } catch (error) {
      console.log('UnconstrainedForecastViewScreenStore fetchForecastProgress => ', error);
    } finally {
      this.isUnconstrainedForecastProgressLoading = false;
    }
  };

  generateSupplierForecast = async () => {
    this.issupplierForecastGenerating = true;
    try {
      const data = await supplierForecastService.generateSupplierForecast({
        planning_period: this.getCurrentDate(),
      });
      if (data) {
        toast.success('Supplier Forecast Generated Successfully');
      }
    } catch (error) {
      const status = (error as { response?: { status?: number } })?.response?.status;
      toast.error(status === 403 ? 'Do not have enough access' : 'Failed to generate Supplier Forecast, try again later');
      console.log('generateSupplierForecast', error);
    } finally {
      this.issupplierForecastGenerating = false;
      const currDt = new Date();
      const forecast_period = currDt
        .toISOString()
        .split('T')[0]
        .replace(/-\d{2}$/, '-01');
      this.getSupplierForecastData(forecast_period);
    }
  };

  resetStore = () => {
    // Loading states
    this.isSupplierForecastLoading = false;
    this.isSupplierForecastDownloading = false;
    this.isAllSupplierForecastDownloading = false;
    this.issupplierForecastGenerating = false;
    this.isUnconstrainedForecastProgressLoading = false;

    // Planning data
    this.suplierForecastPlanDate = '';
    this.percentProgress = { percentage: 0 };

    // Supplier forecast data
    this.supplierForecastData = {
      PlanningPeriod: '',
      Supplier: [
        {
          SupplierName: '',
          Segments: [
            {
              Segment: '',
              BulkNDCs: [
                {
                  BulkNDC11: '',
                  NDC10: '',
                  OnHand: 0,
                  OpenPo: 0,
                  Description: '',
                  Lead_Time: null,
                  Pan_Size: null,
                  IsCoveredDrug: false,
                  forecast: [
                    {
                      ForecastPeriod: '',
                      SupplierForecast: 0,
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    };

    // Supplier options
    this.supplierOption = {
      name: '',
    };
    this.supplierNames = [];

    // Forecast data
    this.fssforecastData = [];
    this.nmcforecastData = [];
    this.coveredDrugForecastData = [];

    // Search related state
    this.searchInput = '';
    this.allndc10SearchData = [];
    this.filteredndc10SearchData = [];
    this.allConceptSearchData = [];
    this.filterConceptSearchData = [];
  };
}
